import apiUrl from '../../../constants';
import awsBucketName from '../../../constants';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import {
    Validator
} from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import {
    BasicSelect
} from 'vue-search-select'
import Paginate from 'vuejs-paginate'
import moment from 'moment'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css';

export default {
    name: 'editLoggedbyexecutive',
    components: {
        Paginate,
        VueElementLoading,
        Multiselect,
    },
    data() {
        return {
            awbnumber: '',
            regionName: '',
            hubzonename: '',
            currentHubName: '',
            destinationHubName: '',
            bagCondition: '',
            DEPSbagCondition: '',
            OctroiMRP: '',
            Clientname: '',
            productDescription: '',
            STDreason: '',
            description: '',
            hubOrigin: '',
            Currenthub: '',
            Destinationhub: '',
            lastService: '',
            currentRegion: '',
            editshowtable: false,
            HubZoneId:'',
            newhubList: [],
            ids:'',
            vStatusList: [{
                value: "Intact",
                label: 'Intact'
            }, {
                value: "Torn/Damage",
                label: 'Torn/Damage'
            }, {
                value: "WithoutSeal",
                label: 'WithoutSeal'
            }],
            STDreason: '',

            StatusList: [{
                value: 4,
                label: 'Accidental Damage'
              }, {
                value: 6,
                label: 'Damage due to Rain'
              }, {
                value: 5,
                label: 'Fragile Items'
              }, {
                value: 3,
                label: 'Improper Handling'
              }, {
                value: 1,
                label: 'Liquid Spillage'
              }, {
                value: 7,
                label: 'Natural Calamity'
              }, {
                value: 8,
                label: 'Pilferage'
              }, {
                value: 2,
                label: 'Poor Packaging'
              }],
            hubdroplist: [],
            myStr: '',
            shipmenarr: [],
            hubList:[],
            attachment: null,
            displaytable: false,
            imagesarr: [],
            attachment: null,
            displaytable: false,
            image: '',
            // try
            //path: '${awsBucketName}/1234/wallpaperflare.com_wallpaper-1.jpg',
            //   fname1: 'download.jpeg',
            fname1: 'wallpaperflare.com_wallpaper-1.jpg',
            imgdata: '',
            showModal: false,
            isUploading : false

        };
    },
    mounted() {
        var userToken = window.localStorage.getItem('accessuserToken');
        this.myStr = userToken.replace(/"/g, '');
        this.username = window.localStorage.getItem('username');
    },

    methods: {

        Backinvestigation() {
          if (this.imagesarr.length != []) {
            this.$alertify.error("Please Delete image")

          }
          else{
            this.$router.push({ path: '/DamagedByOperations' });
          }
        },
        resetForm() {
          // if(this.imagesarr.length!=[]){
          //   this.$alertify.error("Please Delete image")
          // }
            this.awbnumber = '',
                this.regionName = '',
                this.hubzonename = '',
                this.imagesarr=[]
                this.currentHubName = '',
                this.destinationHubName = '',
                this.bagCondition = '',
                this.DEPSbagCondition = '',
                this.OctroiMRP = '',
                this.Clientname = '',
                this.productDescription = '',
                this.STDreason = '',
                this.description = '',
                this.hubOrigin = '',
                this.Currenthub = '',
                this.Destinationhub = '',
                this.lastService = '',
                this.currentRegion = '',

                this.$validator.reset(); this.errors.clear();
        },
        searchAwbNumber() {
            this.input = ({
                ShippingID: this.awbnumber
            })
            axios({
                method: 'post',
                url: apiUrl.api_url + 'InvestigationSearchAWb',
                data: this.input,
                headers: {
                    'Authorization': 'Bearer ' + this.myStr
                }
            }).then(result => {
                this.editshowtable = false;
                this.alldata = result.data;
                if (result.data.code == 200) {
                    this.shipmenarr = result.data.result
                    this.gethubList();
                    this.gethubZoneByHubId(this.shipmenarr.CurrentHubID);

                    this.OctroiMRP = this.shipmenarr["OctroiMRP"];
                    this.Clientname = this.shipmenarr["ClientName"];
                    this.productDescription = this.shipmenarr["ProductDesc"];

                    this.description = this.shipmenarr["Description"];
                    this.bagCondition = this.shipmenarr["BagCondition"];
                    this.STDreason = this.shipmenarr["STDReason"];
                    this.hubzonename=this.shipmenarr["hubzonename"]
                    this.editshowtable = true;

                }
                else {
                    this.$alertify.error(result.data.message)
                }
            },
                error => {
                    console.error(error);
                })

        },
        gethubList() {
            axios({
                method: 'post',
                url: apiUrl.api_url + 'getHubdropdownlist',
                data: {},
                headers: {
                    'Authorization': 'Bearer ' + this.myStr
                }
            }).then(result => {
                let finalHubData = []
                result.data.data.forEach((hub) => {
                    finalHubData.push({
                        id: hub.HubID,
                        label: hub.HubName
                    })
                })
                this.editshowtable = false;
                this.newhubList = finalHubData;
                for (let j = 0; j < this.newhubList.length; j++) {
                    if (this.newhubList[j]["id"] == this.shipmenarr["CurrentHubID"]) {
                        this.currentHubName = this.newhubList[j]["label"];
                    }
                }

                for (let k = 0; k < this.newhubList.length; k++) {
                    if (this.newhubList[k]["id"] == this.shipmenarr["OriginHubID"]) {

                        this.hubOrigin = this.newhubList[k]["label"];
                    }
                }
                for (let z = 0; z < this.newhubList.length; z++) {
                    if (this.newhubList[z]["id"] == this.shipmenarr["FinalDestinationID"]) {

                        this.destinationHubName = this.newhubList[z]["label"];
                    }
                }
                this.editshowtable = true;
            },
                error => {
                    console.error(error)
                })
        },

        gethubZoneByHubId(hubID) {
            axios({
                method: 'post',
                url: apiUrl.api_url + 'gethubzonByCurrentHubID',
                data: {
                    "hubids": [hubID]
                },
                headers: {
                    'Authorization': 'Bearer ' + this.myStr
                }
            }).then(result => {
                this.shipmenarr['hubzonename'] = result.data.data[0].hubzonename
                let hubNameList = JSON.parse(localStorage.getItem('hubzoneList'));
                this.HubZoneID= result.data.data[0].HubZoneId
                this.hubzonename = hubNameList[this.HubZoneID]
            },
                error => {
                    console.error(error)
                })
        },
        onFileChange(e) {
          this.attachment = e.target.files[0];
          this.FileSelected = this.attachment;
          this.FileSelected=null;

        },
      uploadFile() {
        if (!this.attachment) {
          this.$alertify.error("Please choose an image");
          return;
        }

        const allowedTypes = ["image/jpeg", "image/jpg", "image/png", "image/gif"];
        if (!allowedTypes.includes(this.attachment.type)) {
          this.$alertify.error("Please upload only allowed file formats");
          return;
        }

        if (this.attachment.size > 614400) {
          this.$alertify.error("Please upload document less than 600KB");
          return;
        }

        if (this.imagesarr.length >= 3) {
          this.$alertify.error("Only three images allowed");
          return;
        }

        let status = (this.statuss !== undefined && this.statuss !== null) ? this.statuss : 0;
        this.isUploading = true
        let form = new FormData();
        form.append('file', this.attachment);
        form.append('shippingid', this.awbnumber);
        form.append('primaryKey', 123);
        form.append('status', status);

        let uploadedFileName = this.attachment.name;
        axios.post(`${apiUrl.api_url}uploadimage`, form)
          .then(result => {
            if (result.data.errorCode == 0) {
              this.imagesarr.push({ file: uploadedFileName, imgPath: result.data.data });
              this.displaytable = this.imagesarr.length > 0;
              this.$alertify.success("Image uploaded successfully");
            } else {
              this.$alertify.error(`Failed to upload image as : ${result.data.msg}`);
            }
            this.isUploading = false
            this.attachment = null;
            this.FileSelected = null;
          })
          .catch(err => {
            console.error(err);
            this.displaytable = false;
            this.$alertify.error(`Upload failed as : ${err}`);
            this.isUploading = false
            this.attachment = null;
            this.FileSelected = null;
          });
      },
          downloadImage(filePath) {
            this.imgData = filePath;
            this.showModal = true;
          },

          closeImage() {
            this.showModal = false;
          },

          deleteImage(i) {
            let fileName = this.imagesarr[i].file?this.imagesarr[i].file:'';
            const currentdate = moment(new Date()).format("DD_MM_YYYY");

            this.input = ({
              key: `STD/${this.awbnumber}/${currentdate}_${fileName}`,
              file: fileName
            });

            axios({
              method: 'post',
              url: `${apiUrl.api_url}deleteimage`,
              data: this.input,
              headers: {
                'Content-Type': 'application/json',
              },
            }).then((result) => {
              if (result.data.errorCode == 0) {
                if (i > -1) {
                  this.imagesarr.splice(i, 1);
                  this.$alertify.error(result.data.msg);
                }
              } else {
                console.error(result.data.data);
                this.$alertify.error(result.msg);
              }
            },
              (error) => {
                console.error(error);
              });
          },
        updatedata() {
            if(!this.description){
                this.$alertify.error("Please Fill Description.")

            }
            else if (!this.DEPSbagCondition.value) {
              this.$alertify.error("Please Select DEPS Bag Condition.")
            }
            else if (!this.STDreason) {
              this.$alertify.error("Please Select STD Reason.")
            }
            else if(this.imagesarr.length<=2){
                this.$alertify.error("Please Upload Three images")

              }
            else{
            let currentdate = moment(new Date()).format("DD-MM-YYYY HH:mm:ss");

            let cid = this.shipmenarr["CurrentHubID"]
            var currenthubid = cid.toString()
            this.input = ({
                ShippingID: this.awbnumber,
                CurrentHubID: currenthubid,
                ShipmentVerifiedAs: this.username,
                Status: "1",
                STDbagcondition:this.DEPSbagCondition.label,
                StatusMarkedFrom: "Web",
                Comments: this.description,
                LastModifiedBy: this.username,
                LastModifiedDate: currentdate,
                FinanceLoggeddate: currentdate,
                BucketTypeCode:4,
                ActionStatusCode: "",//need
               // IsReattempt: "",//need
               RequestFrom: "Finance",//need
               HubZoneID:this.HubZoneID,

            })
            axios({
                method: 'post',
                url: apiUrl.api_url + 'AddToInvestigation',
                data: this.input,
                headers: {
                    'Authorization': 'Bearer ' + this.myStr
                }
            }).then(result => {
                if (result.data.code == 200) {
                    this.$alertify.success(result.data.message)
                    this.resetForm()             
                  }
                else {
                    this.$alertify.error(result.data.message)
                }
            })
        }
    },
}
};



// WEBPACK FOOTER //
// ./src/views/components/AddExcutive/AddExecutive.component.js